import { Flex, Text } from "@chakra-ui/react";
import { useUI } from "providers/UIProvider";

interface IReservationDetailsDiscount {
    discount: number
    discountPercent: number
    discountType: string
}

const ReservationDetailsDiscount: React.FC<IReservationDetailsDiscount> = ({ discount, discountPercent, discountType }) => {

    const { T } = useUI();

    return (
        <Flex
            padding="16px 23px"
            justifyContent="space-between"
            borderBottom="1px solid #E9F2FD"
            width="100%"
            alignItems="center"
            height="50px"
        >
            <Flex alignItems="center" gap={3}>
                <Text fontSize="12px" fontWeight="medium">{T("bookings.discount")}:</Text>
                <Text fontSize="14px" color="#08BA36" fontWeight="bold">{discountType ? discountType : "No Discount"}</Text>
            </Flex>

            <Flex
                style={{
                    height: "32px",
                    width: "129px",
                    border: "1px solid #08BA36",
                    borderRadius: "100px",
                    justifyContent: "space-between",
                    padding: "0",
                }}>
                <Flex style={{
                    width: "50%",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <Text color="#08BA36"
                        fontSize="18px"
                        fontWeight="500px" >
                        {discountPercent ? discountPercent : "0"}%
                    </Text>
                </Flex>
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    fontSize="18px"
                    color="white"
                    height="31px"
                    width="50%"
                    fontWeight="500"
                    borderRadius="14px"
                    backgroundColor="#08BA36"
                >
                    {discount}₾
                </Flex>
            </Flex>
        </Flex>
    )
};

export default ReservationDetailsDiscount;